// Task Nomenclature Manager
// Manage all 18 task-related nomenclature types

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NOMENCLATURE_TYPES } from '../../../services/taskNomenclatureService';
import { getNomenclatureTypeLabelKey } from '../../../utils/translateNomenclature';
import GenericTaskNomenclatureList from './GenericTaskNomenclatureList';
import InitializeTaskNomenclaturesButton from './InitializeTaskNomenclaturesButton';
import './TaskNomenclatureManager.css';

const TaskNomenclatureManager = ({ userId }) => {
  const { t } = useTranslation();
  const [activeType, setActiveType] = useState(NOMENCLATURE_TYPES.TASK_TYPES);

  const nomenclatureTypes = [
    { key: NOMENCLATURE_TYPES.TASK_TYPES },
    { key: NOMENCLATURE_TYPES.TASK_STATUSES },
    { key: NOMENCLATURE_TYPES.TASK_PRIORITIES },
    { key: NOMENCLATURE_TYPES.TASK_URGENCIES },
    { key: NOMENCLATURE_TYPES.ASSIGNMENT_TYPES },
    { key: NOMENCLATURE_TYPES.RECURRENCE_FREQUENCIES },
    { key: NOMENCLATURE_TYPES.PATIENT_CONDITIONS },
    { key: NOMENCLATURE_TYPES.ISOLATION_LEVELS },
    { key: NOMENCLATURE_TYPES.EQUIPMENT_TYPES_TASK },
    { key: NOMENCLATURE_TYPES.PROCEDURE_TYPES },
    { key: NOMENCLATURE_TYPES.ENVIRONMENTAL_RISKS },
    { key: NOMENCLATURE_TYPES.SHIFT_TYPES },
    { key: NOMENCLATURE_TYPES.COMPLETION_QUALITIES },
    { key: NOMENCLATURE_TYPES.DEVIATION_TYPES },
    { key: NOMENCLATURE_TYPES.RISK_LEVELS },
    { key: NOMENCLATURE_TYPES.GROUP_TYPES },
    { key: NOMENCLATURE_TYPES.WORKLOAD_BALANCING_METHODS },
    { key: NOMENCLATURE_TYPES.NOTIFICATION_CHANNELS }
  ];

  return (
    <div className="task-nomenclature-manager">
      <div className="nomenclature-header">
        <div>
          <h2>Task Nomenclatures</h2>
          <p className="subtitle">Manage task-related nomenclatures and configurations</p>
        </div>
        <InitializeTaskNomenclaturesButton userId={userId} />
      </div>

      <div className="nomenclature-layout">
        {/* Sidebar */}
        <div className="nomenclature-sidebar">
          {nomenclatureTypes.map(type => (
            <button
              key={type.key}
              className={`nomenclature-tab ${activeType === type.key ? 'active' : ''}`}
              onClick={() => setActiveType(type.key)}
            >
              <span className="tab-label">{t(getNomenclatureTypeLabelKey(type.key))}</span>
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="nomenclature-content">
          <GenericTaskNomenclatureList
            key={activeType}
            nomenclatureType={activeType}
            userId={userId}
          />
        </div>
      </div>
    </div>
  );
};

export default TaskNomenclatureManager;

